function getAvailableDesiredProducts (baselineProducts, desiredProducts) {
  let products = []
  // grab the array of products we're looking for and iterate through them

  desiredProducts.forEach(function (product) {
    // if the desired product was returned from baseline, lets add it to our available products array
    if (baselineProducts[product.baselineProductID].totalAvailableProceeds) {
      Object.assign(product, baselineProducts[product.baselineProductID])
      product.available = true
    } else {
      product.available = false
    }
    products = [
      product,
      ...products
    ] // add our found product to our availableProducts array
  })
  return products
}

function sortProducts (products) {
  products.sort((a, b) =>
    a.totalAvailableProceeds < b.totalAvailableProceeds ? 1 : -1
  )
  return products
}

function filterProducts (products) {
  return products.filter(product => {
    return product.available === true
  })
}

export function desiredProductArrayIndex (productName, products) {
  const indexPosition = products.map(function (product) {
    return product.name
  }).indexOf(productName)
  return indexPosition
}

export function getOrganizedProducts (baselineProducts, desiredProducts) {
  let products = getAvailableDesiredProducts(baselineProducts, desiredProducts)
  products = filterProducts(products)
  products = sortProducts(products)
  return products
}
